import React, {useEffect, useState} from 'react';
import SideBar from "../../../../../common/SideBar";
import NavBar from "../../../../../common/NavBar";
import {Link} from "react-router-dom";
import {makeStyles} from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import InputMask from "react-input-mask";
import {toast, ToastContainer} from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import Spinner from "reactjs-simple-spinner";
import ClaimsService from "../../../../../services/ClaimsService";
import 'react-modern-calendar-datepicker/lib/DatePicker.css';
import PoliciesService from "../../../../../services/PoliciesService";
import BeneficiaryService from "../../../../../services/BeneficiaryService";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@material-ui/core/TextField";
import TableContainer from "@material-ui/core/TableContainer";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import TableBody from "@material-ui/core/TableBody";
import PolicyHoldersService from "../../../../../services/PolicyHoldersService";
import FilesService from "../../../../../services/FilesService";
import DatePicker, {utils} from "react-modern-calendar-datepicker";
import {MenuItem} from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
    },
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        width: 250,
    },
    button: {
        marginTop: theme.spacing(1),
        marginRight: theme.spacing(1),
    },
    actionsContainer: {
        marginBottom: theme.spacing(2),
    },
    resetContainer: {
        padding: theme.spacing(3),
    },
    root1: {
        width: '100%',
    },
    heading: {
        fontSize: theme.typography.pxToRem(15),
        flexBasis: '33.33%',
        flexShrink: 0,
    },
    secondaryHeading: {
        fontSize: theme.typography.pxToRem(15),
        color: theme.palette.text.secondary,
    },
    paper: {
        position: 'absolute',
        width: "45%",
        backgroundColor: theme.palette.background.paper,
        border: '0.2px solid #000',
        boxShadow: theme.shadows[1],
        padding: theme.spacing(2, 4, 3),
    },
}));


//beneficiary init
const initialBeneficiary = {
    name: "",
    surname: "",
    relationship: "",
    date_of_birth: "",
    id_number: "",
    mobile_number: "",
    policy_id: ""
}

//dependent init


const initialSpouse = {
    name: "",
    surname: "",
    person_type: "SPOUSE",
    date_of_birth: "",
    id_number: "",
    relationship: "",
    mobile_number: "",
    policy_id: "",
    gender: "",
    premium: ""
}


const AddInothoAccident = (props) => {

    // let history = useHistory();
    const classes = useStyles();


    const [policies, setPolicies] = useState([])
    const [policy, setPolicy] = useState({})

    //objects init
    const [beneficiary, setBeneficiary] = useState(initialBeneficiary);
    // const [dependent, setDependent] = useState(initialDependent);
    const [spouse, setSpouse] = useState(initialSpouse);
    // const [child, setChild] = useState(initialChild);
    const [family, setFamily] = useState([])
    const [extendedFamily, setExtendedFamily] = useState([])
    const [parent, setParent] = useState([])


    // const [claim, setClaim] = useState({});
    const [loading, setLoading] = useState(false);
    const [searchLoading, setSearchLoading] = useState(false);


    // const [selectedDay, setSelectedDay] = useState(null);
    const [policyNumber, setPolicyNumber] = useState(null);
    const [claimReason, setClaimReason] = useState(null);
    const [street, setStreet] = useState(null);
    const [suburb, setSuburb] = useState(null);
    const [city, setCity] = useState(null);
    const [amountClaimed, setAmountClaimed] = useState(0);
    const [show, setShow] = useState(false);
    const [message, setMessage] = useState('');
    const [files, setFiles] = useState({});
    const [uploadLoading1, setUploadLoading1] = useState(false);

    const [accountName, setAccountName] = useState(null);
    const [bank, setBank] = useState(null);
    const [accountNumber, setAccountNumber] = useState(null);
    const [branch, setBranch] = useState(null);
    const [walletName, setWalletName] = useState(null);
    const [mobileNumber, setMobileNumber] = useState(null);
    const [mobileAccountNumber, setMobileAccountNumber] = useState(null);
    const [file, setFile] = useState(0);
    const [dateOfInjury, setDateOfInjury] = useState(null);
    const [descriptionAccident, setDescriptionAccident] = useState(null);

    const handleFileChange1 = (e) => {
        setUploadLoading1(true);
        console.log(e);
        const file = e.target.files[0];
        let name = e.target.name
        const formData = new FormData();
        formData.append("file", file);
        formData.append('policy_number', policy.policy_number)
        FilesService.savingsWithdrawalUpload(formData)
            .then(res => {
                console.log(res)
                setMessage('Successful');
                setFiles({...files, [name]: name})
                setFile(1)
                setUploadLoading1(false);
            })
            .catch(err => {
                setUploadLoading1(false);
                setMessage('');
                console.log(err);
            });
    }

    const [payoutMethod, setPayoutMethod] = useState(false)

    const [showBankDetails, setShowBankDetails] = useState(false);
    const [showMobileDetails, setShowMobileDetails] = useState(false);

    const handleChange = name => ({target: {value}}) => {
        if (name === 'policyNumber') {
            setPolicyNumber(value);
        }
        if (name === 'claimReason') {
            setClaimReason(value);
        }

        if (name === 'street') {
            setStreet(value)
        }
        if (name === 'suburb') {
            setSuburb(value)
        }
        if (name === 'city') {
            setCity(value)
        }
        if (name === 'cashPayOutMethod' && value === 'true') {
            setShowBankDetails(false);
            setShowMobileDetails(true);
            setPayoutMethod(value)
        }
        if (name === 'amountClaimed') {
            setAmountClaimed(value);
        }
        if (name === 'cashPayOutMethod' && value === 'false') {
            setShowMobileDetails(false);
            setShowBankDetails(true);
            setPayoutMethod(value)
        }
        if (name === 'accountName') {
            setAccountName(value)
        }
        if (name === 'bank') {
            setBank(value)
        }
        if (name === 'branch') {
            setBranch(value)
        }
        if (name === 'accountNumber') {
            setAccountNumber(value)
        }
        if (name === 'walletName') {
            setWalletName(value)
        }
        if (name === 'mobileNumber') {
            setMobileNumber(value)
        }
        if (name === 'mobileAccountNumber') {
            setMobileAccountNumber(value)
        }
        if (name === 'descriptionAccident') {
            setDescriptionAccident(value)
        }
    }

    // eslint-disable-next-line react-hooks/rules-of-hooks
    useEffect(() => {
        setLoading(true)
        setPolicy({})
        setPolicyHolder({})
        setShowBankDetails(false);
        setShowMobileDetails(false);
        setMessage('');
        setShow(false)
        let token = JSON.parse(localStorage.getItem('token'));

        console.log("token", token)
        //    get allPolicies
        PoliciesService.getAllPolicies()
            .then(response => {
                let d = [];
                console.log("res: ", response)
                response.data.policies.map((i, p) => {
                    if (i.policy_type === "PFUMA / INOTHO") {
                        d.push(i);
                        setPolicies(d)
                    }
                })
                setLoading(false)
            }).catch(err => {
            console.error(err)
            setPolicies([])
            setLoading(false)
        })

    }, []);

    const defaultProps = {
        options: policies,
        getOptionLabel: (option) => option.policy_number,
    };

    const [policyHolder, setPolicyHolder] = useState({})

    const handleSearch = () => {
        setLoading(true);
        setAccountName('');
        setAccountNumber('');
        setBank('');
        setBranch('');
        setMobileAccountNumber('');
        setWalletName('')

        if (policyNumber === '' || policyNumber === undefined) {
            setLoading(false)
            toast.warning('Please provide a policy number');
            return
        }
        //    search for policy details by policyNumber
        PoliciesService.searchPolicy(policyNumber)
            .then(response => {
                console.log("res: ", response)
                if (response.status === 200) {
                    setShow(true);
                    setPolicyNumber('')
                    setPolicy(response.data.policy)
                    // get policyHolder
                    PolicyHoldersService.getPolicyHolder(response.data.policy.policy_holder_id).then(res => {
                        setPolicyHolder(res.data.policyHolder);
                        setLoading(false);
                    }).catch(err => {
                        toast.warning('Loading Assured Failed \n If error persists contact, System Administrator', {
                            position: "top-right",
                            autoClose: 3000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                        });
                        console.log("error: ", err);
                        setLoading(false);
                    })
                    //    get
                    BeneficiaryService.getBeneficiaries(response.data.policy.id).then(res => {
                        setLoading(true)
                        if (res.status === 200) {
                            console.log("beneficiary: ", res.data.beneficiary);
                            //if true hide add button
                            if (res.data.beneficiary.length === 0) {
                                setBeneficiary(initialBeneficiary)
                            } else {
                                setBeneficiary(res.data.beneficiary[0]);
                            }
                            setLoading(false);

                        } else {
                            setLoading(false);
                            toast.warning('Loading Beneficiary Failed \n If error persists contact, System Administrator', {
                                position: "top-right",
                                autoClose: 3000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true,
                                progress: undefined,
                            });
                            console.log("error: ", res);

                        }
                    }).catch(err => {
                        toast.warning('Loading Beneficiary Failed \n If error persists contact, System Administrator', {
                            position: "top-right",
                            autoClose: 3000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                        });
                        console.log("error: ", err);
                        setLoading(false);
                    })
                    //get all dependants with policyId
                    BeneficiaryService.getDependencies(response.data.policy.id).then(res => {
                        console.log("dependants: ", res);
                        if (res.status === 200) {
                            if (res.data.dependents.spouse_cover.length > 0) {
                                setSpouse(res.data.dependents.spouse_cover[0]);
                            } else {
                                setSpouse(initialSpouse)
                            }

                            if (res.data.dependents.family_cover.length > 0) {
                                setFamily(res.data.dependents.family_cover);
                            } else {
                                setFamily([])
                            }
                            if (res.data.dependents.parent_cover.length > 0) {
                                setParent(res.data.dependents.parent_cover);
                            } else {
                                setParent([])
                            }
                            if (res.data.dependents.extended_cover.length > 0) {
                                setExtendedFamily(res.data.dependents.extended_cover);
                            } else {
                                setExtendedFamily([])
                            }

                            setLoading(false);
                        } else {
                            setLoading(false);
                            console.log("error: ", res);
                            toast.warning('Loading Dependencies Failed \n If error persists contact, System Administrator', {
                                position: "top-right",
                                autoClose: 3000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true,
                                progress: undefined,
                            });
                        }


                    }).catch(err => {
                        console.log("error: ", err);
                        toast.warning('Loading Dependencies Failed \n If error persists contact, System Administrator', {
                            position: "top-right",
                            autoClose: 3000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                        });
                        setLoading(false);
                    })

                }
            }).catch(err => {
            console.log("error: ", err)
            setPolicy({})
            setLoading(false);
            toast.warning('Network Error, Try again \nIf error persists contact System Administrator ');
            console.log('err: ', err)
        })

    }

    const handleChangePolicyNumber = (e, v, name) => {
        if (v.policy_number === null || v.policy_number === undefined) {
            console.log(v.policy_number)
            setPolicyNumber('')
        } else {
            console.log(v.policy_number)
            setPolicyNumber(v.policy_number)
        }

    }


    const handleSave = (e) => {
        e.preventDefault();

        let iDate;

        setLoading(true);

        if (bank === null) {
            setBank('none')
        }
        if (branch === null) {
            setBranch('none')
        }
        if (accountName === null) {
            setAccountName('none')
        }
        if (accountNumber === null) {
            setAccountNumber('none')
        }
        if (mobileNumber === null) {
            setMobileNumber('0000000000')
        }
        if (mobileAccountNumber === null) {
            setMobileAccountNumber('none')
        }
        if (walletName === null) {
            setWalletName('none')
        }
        //injury date
        if (dateOfInjury.day < 10) {
            console.log(dateOfInjury.year + '-' + dateOfInjury.month + '-0' + dateOfInjury.day);
            iDate = dateOfInjury.year + '-' + dateOfInjury.month + '-0' + dateOfInjury.day
        } else {
            console.log(dateOfInjury.year + '-' + dateOfInjury.month + '-' + dateOfInjury.day);
            iDate = dateOfInjury.year + '-' + dateOfInjury.month + '-' + dateOfInjury.day;
        }

        let data = {
            "policy_number": policy.policy_number,
            "id_number": policyHolder.id_number,
            "first_name_of_assured": policyHolder.first_name,
            "last_name_of_assured": policyHolder.last_name,
            "email": policyHolder.email,
            "postal_address": street + '-' + suburb + '-' + city,
            "amount_claimed": amountClaimed,
            "inception_date": policy.commencement_date,
            "claim_reason": claimReason,
            "bank": bank,
            "account_branch": branch,
            "account_number": accountNumber,
            "account_name": accountName,
            "wallet_name": walletName,
            "mobile_number": mobileNumber,
            "mobile_account_number": mobileAccountNumber,
            "cash_payout": JSON.parse(payoutMethod),
            "accident_description": descriptionAccident,
            "date_of_injury": iDate,
            'file': file

        }

        console.log(data)

        ClaimsService.inothoPersonalAccident(data)
            .then(res => {
                console.log(res.status)
                if (res.status === 201 || res.status === 200) {
                    setShow(false);
                    toast.success('Claim Initiated', {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                    setLoading(false);
                    // history.push('/claims');

                } else if (res.status === 400) {
                    toast.warning('Wrong inputs!! Please check your details', {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                    setLoading(false);

                } else {
                    console.log("error: " + res.response.data.message);
                    setLoading(false);
                    toast.warning(res.response.data.message, {
                        position: "top-center",
                        autoClose: 3000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: false,
                        draggable: true,
                        progress: undefined,
                    });
                }

            })
            .catch(err => {
                setLoading(false)
                toast.warning('Operation Failed, Error: ' + err.response.data.message, {
                    position: "top-center",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
                console.log(err);
            });
    }

    return (
        <div>
            <ToastContainer
                position="top-center"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                draggable
                pauseOnHover
            />
            <SideBar roles={JSON.parse(localStorage.getItem('roles'))}/>
            <div id="main-content" className="main-panel ps-container ps-theme-default">
              <NavBar roles={JSON.parse(localStorage.getItem('roles'))}/>
                <div className="content">
                    <div className="container-fluid">
                        <ul className="breadcrumb">
                            <Link to="/dashboard"><a href><i className="fa fa-home"/>&nbsp;Dashboard</a> </Link>
                             &nbsp;|&nbsp;
                            <Link to="/claims"><a href><i className="fa-solid fa-basket-shopping"/>&nbsp;Claims</a>
                            </Link>
                            &nbsp;|&nbsp;
                            <Link to="/pfuma-claims"><a href><i className="fa-solid fa-cow"/>&nbsp;Pfuma
                                Claims</a> </Link>
                            &nbsp;|&nbsp;
                            <span className="upper-class">New Personal Accident Claim</span>
                        </ul>

                        <div className="row">
                            <div className="col-lg-12">
                                <div className="card">
                                    {loading && (
                                        <div className="mr-5 ml-5 mt-5 mb-5 p-5">
                                            <Spinner
                                                size="medium"
                                                message="Please wait,Good things takes time....."
                                                line-fg-color="#64c3c2"
                                            />
                                        </div>

                                    )}
                                    {!loading && (
                                        <form id="policyholderData" onSubmit={handleSave} autoComplete="off">
                                            <div id="form-style">
                                                <h4 className="text-primary font-weight-bold">Create Claim</h4>
                                                <div className="row mt">
                                                    <div className="col-md-4 p-3 overflow-hidden">
                                                        {searchLoading && (
                                                            <div className="mr-5 ml-5 mt-5 mb-5 p-5">
                                                                <Spinner
                                                                    size="medium"
                                                                    message="Please wait....."
                                                                    line-fg-color="#64c3c2"
                                                                />
                                                            </div>

                                                        )}
                                                        {!searchLoading && (
                                                            <>
                                                                <div className="row">
                                                                    <div className="col-md-10">
                                                                        <Autocomplete
                                                                            {...defaultProps}
                                                                            id="auto-complete"
                                                                            autoComplete
                                                                            onChange={(e, v) => handleChangePolicyNumber(e, v, props.name)}
                                                                            includeInputInList
                                                                            renderInput={(params) =>
                                                                                <TextField {...params}
                                                                                           label="Search By PolicyNumber"
                                                                                           margin="normal" fullWidth
                                                                                />}
                                                                        />
                                                                    </div>
                                                                    <div className="col-md-2">
                                                                        <button onClick={handleSearch}
                                                                                className="btn btn-sm btn-primary">
                                                                            <i className="fa fa-search"/>&nbsp;
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                                {show && (
                                                                    <>
                                                                        <hr/>
                                                                        <div className="row mt-5">
                                                                            <h4 className="col-md-12 font-weight-bold text-capitalize">Policy
                                                                                Details</h4>
                                                                        </div>
                                                                        <hr/>
                                                                        <div className="row mt-2">
                                                                            <div className="col-sm-6">
                                                                                <h7><b>Policy Number:</b> <span>
                                                {policy.policy_number}
                                            </span>
                                                                                </h7>
                                                                            </div>
                                                                            <div className="col-sm-6">
                                                                                <h7><b>Status:</b> <span>
                                                    <span
                                                        className="badge bg-gradient-success">{policy.policy_status}</span>

                                            </span>
                                                                                </h7>
                                                                            </div>
                                                                        </div>
                                                                        <div className="row mt-2">
                                                                            <div className="col-sm-12">
                                                                                <h7><b>Commencement Date:</b> <span>
                                                {policy.commencement_date}
                                            </span>
                                                                                </h7>
                                                                            </div>
                                                                        </div>
                                                                        <div className="row mt-2">
                                                                            <div className="col-sm-6">
                                                                                <h7><b>Sum Assured:</b> <span>
                                                {policy.sum_assured}
                                            </span>
                                                                                </h7>
                                                                            </div>
                                                                            <div className="col-sm-6">
                                                                                <h7><b>Premium:</b> <span>
                                                {policy.premium}
                                            </span>
                                                                                </h7>
                                                                            </div>
                                                                        </div>
                                                                        <div className="row mt-2">
                                                                            <div className="col-sm-6">
                                                                                <h7><b>Partial Payment:</b> <span>
                                                {policy.balance}
                                            </span>
                                                                                </h7>
                                                                            </div>
                                                                            <div className="col-sm-6">
                                                                                <h7><b>Arrear Balance:</b> <span>
                                                {policy.arrearBalance}
                                            </span>
                                                                                </h7>
                                                                            </div>
                                                                        </div>

                                                                        <hr/>
                                                                        <div className="row mt-5 p-2">
                                                                            <h4 className="col-md-12 font-weight-bold text-capitalize">Beneficiary</h4>
                                                                            <TableContainer component={Paper}>
                                                                                <Table className={classes.table}
                                                                                       aria-label="simple table">
                                                                                    <TableHead>
                                                                                        <TableRow>
                                                                                            <TableCell>Name</TableCell>
                                                                                            <TableCell>Relationship</TableCell>
                                                                                            <TableCell>ID</TableCell>
                                                                                        </TableRow>
                                                                                    </TableHead>
                                                                                    <TableBody>
                                                                                        <TableRow>
                                                                                            <TableCell component="th"
                                                                                                       scope="row">
                                                                                                {beneficiary.name}&nbsp;{beneficiary.surname}
                                                                                            </TableCell>
                                                                                            <TableCell>{beneficiary.relationship}</TableCell>
                                                                                            <TableCell
                                                                                            >{beneficiary.id_number}</TableCell>
                                                                                        </TableRow>
                                                                                    </TableBody>
                                                                                </Table>
                                                                            </TableContainer>
                                                                        </div>
                                                                        <hr/>
                                                                        <div className="row mt-5 p-2">
                                                                            <h4 className="col-md-12 font-weight-bold text-capitalize">Dependants</h4>
                                                                            <hr/>
                                                                            <h5 className="col-md-12 mt-1 font-weight-bold text-capitalize">Spouse</h5>
                                                                            <TableContainer component={Paper}>
                                                                                <Table aria-label="simple table">
                                                                                    <TableHead>
                                                                                        <TableRow>
                                                                                            <TableCell>Name</TableCell>
                                                                                            <TableCell>ID
                                                                                                Number</TableCell>
                                                                                            <TableCell
                                                                                            >Premium</TableCell>
                                                                                        </TableRow>
                                                                                    </TableHead>
                                                                                    <TableBody>
                                                                                        <TableRow>
                                                                                            <TableCell
                                                                                                component="th"
                                                                                                scope="row">
                                                                                                {spouse.name}&nbsp;{spouse.surname}
                                                                                            </TableCell>
                                                                                            <TableCell>{spouse.id_number}</TableCell>
                                                                                            <TableCell
                                                                                            >{spouse.premium}</TableCell>
                                                                                        </TableRow>
                                                                                    </TableBody>
                                                                                </Table>
                                                                            </TableContainer>
                                                                            <hr/>
                                                                            <h5 className="col-md-12 mt-1 font-weight-bold text-capitalize">Children</h5>
                                                                            <TableContainer component={Paper}>
                                                                                <Table aria-label="simple table">
                                                                                    <TableHead>
                                                                                        <TableRow>
                                                                                            <TableCell>Name</TableCell>
                                                                                            <TableCell>ID
                                                                                                Number</TableCell>
                                                                                            <TableCell
                                                                                            >Premium</TableCell>
                                                                                        </TableRow>
                                                                                    </TableHead>
                                                                                    <TableBody>
                                                                                        {family.map((row, i) => {
                                                                                                if (row.person_type === 'CHILD') {
                                                                                                    return (
                                                                                                        <TableRow key={i}>
                                                                                                            <TableCell
                                                                                                                component="th"
                                                                                                                scope="row">
                                                                                                                {row.name}&nbsp;{row.surname}
                                                                                                            </TableCell>
                                                                                                            <TableCell>{row.id_number}</TableCell>
                                                                                                            <TableCell
                                                                                                            >{row.premium}</TableCell>
                                                                                                        </TableRow>
                                                                                                    )
                                                                                                }
                                                                                            }
                                                                                        )}
                                                                                    </TableBody>
                                                                                </Table>
                                                                            </TableContainer>
                                                                            <hr/>
                                                                            <h5 className="col-md-12 mt-1 font-weight-bold text-capitalize">Parents</h5>
                                                                            <TableContainer component={Paper}>
                                                                                <Table aria-label="simple table">
                                                                                    <TableHead>
                                                                                        <TableRow>
                                                                                            <TableCell>Name</TableCell>
                                                                                            <TableCell>ID
                                                                                                Number</TableCell>
                                                                                            <TableCell
                                                                                            >Premium</TableCell>
                                                                                        </TableRow>
                                                                                    </TableHead>
                                                                                    <TableBody>
                                                                                        {parent.map((row, i) => (
                                                                                            <TableRow key={i}>
                                                                                                <TableCell
                                                                                                    component="th"
                                                                                                    scope="row">
                                                                                                    {row.name}&nbsp;{row.surname}
                                                                                                </TableCell>
                                                                                                <TableCell>{row.id_number}</TableCell>
                                                                                                <TableCell
                                                                                                >{row.premium}</TableCell>
                                                                                            </TableRow>
                                                                                        ))}
                                                                                    </TableBody>
                                                                                </Table>
                                                                            </TableContainer>
                                                                            <hr/>
                                                                            <h5 className="col-md-12 mt-1 font-weight-bold text-capitalize">Extended
                                                                                Family</h5>
                                                                            <TableContainer component={Paper}>
                                                                                <Table aria-label="simple table">
                                                                                    <TableHead>
                                                                                        <TableRow>
                                                                                            <TableCell>Name</TableCell>
                                                                                            <TableCell>ID
                                                                                                Number</TableCell>
                                                                                            <TableCell
                                                                                            >Premium</TableCell>
                                                                                        </TableRow>
                                                                                    </TableHead>
                                                                                    <TableBody>
                                                                                        {extendedFamily.map((row, i) => (
                                                                                            <TableRow key={i}>
                                                                                                <TableCell
                                                                                                    component="th"
                                                                                                    scope="row">
                                                                                                    {row.name}&nbsp;{row.surname}
                                                                                                </TableCell>
                                                                                                <TableCell>{row.id_number}</TableCell>
                                                                                                <TableCell>{row.premium}</TableCell>
                                                                                            </TableRow>
                                                                                        ))}
                                                                                    </TableBody>
                                                                                </Table>
                                                                            </TableContainer>
                                                                        </div>
                                                                    </>
                                                                )}

                                                            </>

                                                        )}

                                                    </div>
                                                    {show && (
                                                        <div className="col-md-8 border border-gray p-4">
                                                            <div className={classes.root}>

                                                                <div>

                                                                    <div className="row">
                                                                        <div className="form-group col-md-3">
                                                                            <label>
                                                                                <span className="text-danger">*</span>Claimant
                                                                                FirstName</label>
                                                                            <input
                                                                                type="text"
                                                                                autoComplete="off"
                                                                                value={policyHolder.first_name}
                                                                                disabled={true}
                                                                                className="form-control"
                                                                                name="claimantFirstName"
                                                                                onChange={handleChange('claimantFirstName')}
                                                                            />
                                                                            <p className="message">
                                                                                {/*{{ validation.firstError("firstname") }}*/}
                                                                            </p>
                                                                        </div>
                                                                        <div className="form-group col-md-3">
                                                                            <label> <span
                                                                                className="text-danger">*</span>Claimant
                                                                                LastName</label>
                                                                            <input
                                                                                type="text"
                                                                                autoComplete="off"
                                                                                value={policyHolder.last_name}
                                                                                disabled={true}
                                                                                className="form-control"
                                                                                name="claimantLastName"
                                                                                onChange={handleChange('claimantLastName')}
                                                                            />
                                                                            <p className="message">
                                                                                {/*{{ validation.firstError("firstname") }}*/}
                                                                            </p>
                                                                        </div>
                                                                        <div className="form-group col-md-3">
                                                                            <label> <span
                                                                                className="text-danger">*</span>ID
                                                                                Number
                                                                            </label>
                                                                            <InputMask mask='99999999**99'
                                                                                       className="form-control"
                                                                                       maskChar=" "
                                                                                       value={policyHolder.id_number}
                                                                                       disabled={true}
                                                                                       required
                                                                                       name="claimantIdNumber"
                                                                                       onChange={handleChange('claimantIdNumber')}
                                                                            />

                                                                        </div>
                                                                        <div className="form-group col-md-3">
                                                                            <label> <span
                                                                                className="text-danger">*</span>Email</label>
                                                                            <input
                                                                                type="email"
                                                                                autoComplete="off"
                                                                                className="form-control"
                                                                                name="claimantEmail"
                                                                                value={policyHolder.email}
                                                                                disabled={true}
                                                                                onChange={handleChange('claimantEmail')}
                                                                            />
                                                                            <p className="message">
                                                                                {/*{{ validation.firstError("firstname") }}*/}
                                                                            </p>
                                                                        </div>
                                                                    </div>

                                                                    <div className="form-row">

                                                                        <div className="form-group col-md-3">
                                                                            <label> <span
                                                                                className="text-danger">*</span>Inception
                                                                                Date</label>
                                                                            <input
                                                                                type="text"
                                                                                autoComplete="off"
                                                                                className="form-control"
                                                                                name="inceptionDate"
                                                                                value={policy.commencement_date}
                                                                                disabled={true}
                                                                                onChange={handleChange('inceptionDate')}
                                                                            />
                                                                            <p className="message">
                                                                                {/*{{ validation.firstError("lastname") }}*/}
                                                                            </p>
                                                                        </div>
                                                                        <div className="form-group col-md-3">
                                                                            <label> <span
                                                                                className="text-danger">*</span>Amount
                                                                                Claimed</label>
                                                                            <input
                                                                                type="tel"
                                                                                autoComplete="off"
                                                                                className="form-control"
                                                                                name="amountClaimed"
                                                                                value={amountClaimed}
                                                                                onChange={handleChange('amountClaimed')}
                                                                            />
                                                                            <p className="message">
                                                                                {/*{{ validation.firstError("firstname") }}*/}
                                                                            </p>
                                                                        </div>
                                                                        <div className="form-group col-md-4">
                                                                            <label> <span
                                                                                className="text-danger">*</span>Date of
                                                                                Accident</label>
                                                                            <br/>
                                                                            <DatePicker
                                                                                value={dateOfInjury}
                                                                                onChange={setDateOfInjury}
                                                                                maximumDate={utils().getToday()}
                                                                                inputPlaceholder="Select Date"
                                                                                shouldHighlightWeekends
                                                                            />

                                                                            <br/>

                                                                            <p className="message">
                                                                                {/*{{ validation.firstError("dateOfBirth") }}*/}
                                                                            </p>
                                                                        </div>

                                                                    </div>
                                                                    <div className="row mt-4 mb-4">
                                                                        <div className="col-md-12">
                                                                            <label htmlFor=""> <span
                                                                                className="text-danger">*</span>Accident
                                                                                Description</label>
                                                                            <textarea
                                                                                onChange={handleChange('descriptionAccident')}
                                                                                className="form-control"
                                                                                value={descriptionAccident}
                                                                                rows="6"
                                                                                placeholder="Enter Description Of Accident">
                            </textarea>
                                                                        </div>
                                                                    </div>
                                                                    <hr/>
                                                                    <div>
                                                                        <div className="row mt-3">
                                                                            <h5 className="text-primary font-weight-bold">Financial
                                                                                Details</h5>
                                                                        </div>
                                                                        <div className="row">

                                                                            <div className="form-group mb-3 col-md-6">
                                                                                <label>
                                                                                    <strong>CASH PAYOUT</strong>
                                                                                </label>
                                                                                <select name="cashPayOutMethod" id=""
                                                                                        className="form-control"
                                                                                        onChange={handleChange('cashPayOutMethod')}>
                                                                                    <option value selected>Select
                                                                                        Option
                                                                                    </option>
                                                                                    <option value={true}>Yes</option>
                                                                                    <option value={false}>No</option>
                                                                                </select>
                                                                            </div>
                                                                        </div>
                                                                        {showBankDetails && (
                                                                            <div className="row">

                                                                                <div className="form-group col-md-12">
                                                                                    <label>
                                                                                        <strong>BANK PAYOUT</strong>
                                                                                    </label>
                                                                                </div>
                                                                                <div className="form-group col-md-3">
                                                                                    <label>Account Name</label>
                                                                                    <input
                                                                                        type="tel"
                                                                                        autoComplete="off"
                                                                                        className="form-control"
                                                                                        name="accountName"
                                                                                        value={accountName}
                                                                                        onChange={handleChange('accountName')}
                                                                                    />
                                                                                    <p className="message">
                                                                                        {/*{{ validation.firstError("lastname") }}*/}
                                                                                    </p>
                                                                                </div>
                                                                                <div className="form-group col-md-3">
                                                                                    <label>Bank Name</label>
                                                                                    <input
                                                                                        type="text"
                                                                                        autoComplete="off"
                                                                                        className="form-control"
                                                                                        name="bank"
                                                                                        value={bank}
                                                                                        onChange={handleChange('bank')}
                                                                                    />
                                                                                    <p className="message">
                                                                                        {/*{{ validation.firstError("firstname") }}*/}
                                                                                    </p>
                                                                                </div>
                                                                                <div className="form-group col-md-3">
                                                                                    <label>Account Number</label>
                                                                                    <input
                                                                                        type="tel"
                                                                                        autoComplete="off"
                                                                                        className="form-control"
                                                                                        name="accountNumber"
                                                                                        value={accountNumber}
                                                                                        onChange={handleChange('accountNumber')}
                                                                                    />
                                                                                    <p className="message">
                                                                                        {/*{{ validation.firstError("lastname") }}*/}
                                                                                    </p>
                                                                                </div>

                                                                                <div className="form-group col-md-3">
                                                                                    <label>Branch</label>
                                                                                    <input
                                                                                        type="text"
                                                                                        autoComplete="off"
                                                                                        className="form-control"
                                                                                        name="branch"
                                                                                        value={branch}
                                                                                        onChange={handleChange('branch')}
                                                                                    />
                                                                                    <p className="message">
                                                                                        {/*{{ validation.firstError("firstname") }}*/}
                                                                                    </p>
                                                                                </div>
                                                                            </div>
                                                                        )}
                                                                        {showMobileDetails && (
                                                                            <div className="mb-3 form-row">
                                                                                <div className="form-group col-md-12">
                                                                                    <label>
                                                                                        <strong>MOBILE PAYOUT</strong>
                                                                                    </label>
                                                                                </div>
                                                                                <div className="form-group col-md-4">
                                                                                    <label>Wallet Name</label>
                                                                                    <select name="walletName" id=""
                                                                                            className="form-control"
                                                                                            onChange={handleChange('walletName')}>
                                                                                        <option value selected>Select
                                                                                            Option
                                                                                        </option>
                                                                                        <option
                                                                                            value="ECOCASH">ECOCASH
                                                                                        </option>
                                                                                        <option
                                                                                            value="TELECASH">TELECASH
                                                                                        </option>
                                                                                        <option value="ONE_WALLET">ONE
                                                                                            WALLET
                                                                                        </option>
                                                                                    </select>
                                                                                </div>

                                                                                <div className="form-group col-md-4">
                                                                                    <label>Mobile Number</label>
                                                                                    <input
                                                                                        type="text"
                                                                                        autoComplete="off"
                                                                                        className="form-control"
                                                                                        name="mobileNumber"
                                                                                        value={mobileNumber}
                                                                                        onChange={handleChange('mobileNumber')}
                                                                                    />
                                                                                </div>
                                                                                <div className="form-group col-md-4">
                                                                                    <label>Account Number</label>
                                                                                    <input
                                                                                        type="text"
                                                                                        autoComplete="off"
                                                                                        className="form-control"
                                                                                        name="mobileAccountNumber"
                                                                                        value={mobileAccountNumber}
                                                                                        onChange={handleChange('mobileAccountNumber')}
                                                                                    />
                                                                                </div>
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                    <hr/>
                                                                    <div className="form-row">
                                                                        <div className="form-group col-md-12">
                                                                            <label>
                                                                                <strong>POSTAL ADDRESS</strong>
                                                                            </label>
                                                                        </div>
                                                                        <div className="form-group col-md-4">
                                                                            <label> <span
                                                                                className="text-danger">*</span>Street</label>
                                                                            <input
                                                                                type="text"
                                                                                className="form-control"
                                                                                name="street"
                                                                                value={street}
                                                                                autoComplete="off"
                                                                                onChange={handleChange('street')}
                                                                            />
                                                                        </div>
                                                                        <div className="form-group col-md-4">
                                                                            <label> <span
                                                                                className="text-danger">*</span>Suburb</label>
                                                                            <input
                                                                                type="text"
                                                                                autoComplete="off"
                                                                                className="form-control"
                                                                                name="suburb"
                                                                                value={suburb}
                                                                                onChange={handleChange('suburb')}
                                                                            />
                                                                        </div>
                                                                        <div className="form-group col-md-4">
                                                                            <label> <span
                                                                                className="text-danger">*</span>City</label>
                                                                            <TextField
                                                                                onChange={handleChange('city')}
                                                                                name="city"
                                                                                select
                                                                                fullWidth
                                                                                required>
                                                                                {city !== '' && (
                                                                                    <MenuItem selected={true}
                                                                                              value={city}>
                                                                                        {city}
                                                                                    </MenuItem>
                                                                                )}
                                                                                <MenuItem value disabled={true}>Select
                                                                                    City</MenuItem>
                                                                                <MenuItem
                                                                                    value="Arcturus">Arcturus</MenuItem>
                                                                                <MenuItem
                                                                                    value="Banket">Banket</MenuItem>
                                                                                <MenuItem
                                                                                    value="Beitbridge">Beitbridge</MenuItem>
                                                                                <MenuItem
                                                                                    value="Bindura">Bindura</MenuItem>
                                                                                <MenuItem
                                                                                    value="Buhera">Buhera</MenuItem>
                                                                                <MenuItem
                                                                                    value="Bulawayo">Bulawayo</MenuItem>
                                                                                <MenuItem
                                                                                    value="Chegutu">Chegutu</MenuItem>
                                                                                <MenuItem
                                                                                    value="Chimanimani">Chimanimani</MenuItem>
                                                                                <MenuItem
                                                                                    value="Chinhoyi">Chinhoyi</MenuItem>
                                                                                <MenuItem
                                                                                    value="Chipinge">Chipinge</MenuItem>
                                                                                <MenuItem
                                                                                    value="Chiredzi">Chiredzi</MenuItem>
                                                                                <MenuItem
                                                                                    value="Chitungwiza">Chitungwiza</MenuItem>
                                                                                <MenuItem
                                                                                    value="Chivhu">Chivhu</MenuItem>
                                                                                <MenuItem
                                                                                    value="Darwendale">Darwendale</MenuItem>
                                                                                <MenuItem
                                                                                    value="Goromonzi">Goromonzi</MenuItem>
                                                                                <MenuItem
                                                                                    value="Guruve">Guruve</MenuItem>
                                                                                <MenuItem
                                                                                    value="Gwanda">Gwanda</MenuItem>
                                                                                <MenuItem value="Gweru">Gweru</MenuItem>
                                                                                <MenuItem
                                                                                    value="Harare">Harare</MenuItem>
                                                                                <MenuItem
                                                                                    value="Hwange">Hwange</MenuItem>
                                                                                <MenuItem
                                                                                    value="Kadoma">Kadoma</MenuItem>
                                                                                <MenuItem
                                                                                    value="Kariba">Kariba</MenuItem>
                                                                                <MenuItem value="Karoi">Karoi</MenuItem>
                                                                                <MenuItem value="Kezi">Kezi</MenuItem>
                                                                                <MenuItem
                                                                                    value="Kwekwe">Kwekwe</MenuItem>
                                                                                <MenuItem
                                                                                    value="Lupane">Lupane</MenuItem>
                                                                                <MenuItem
                                                                                    value="Marondera">Marondera</MenuItem>
                                                                                <MenuItem
                                                                                    value="Masvingo">Masvingo</MenuItem>
                                                                                <MenuItem value="Mazoe">Mazoe</MenuItem>
                                                                                <MenuItem
                                                                                    value="Mhangura">Mhangura</MenuItem>
                                                                                <MenuItem value="Mount Darwin">Mount
                                                                                    Darwin</MenuItem>
                                                                                <MenuItem
                                                                                    value="Mukumbura">Mukumbura</MenuItem>
                                                                                <MenuItem
                                                                                    value="Murehwa">Murehwa</MenuItem>
                                                                                <MenuItem
                                                                                    value="Mutare">Mutare</MenuItem>
                                                                                <MenuItem
                                                                                    value="Mutoko">Mutoko</MenuItem>
                                                                                <MenuItem
                                                                                    value="Mvurwi">Mvurwi</MenuItem>
                                                                                <MenuItem
                                                                                    value="Norton">Norton</MenuItem>
                                                                                <MenuItem
                                                                                    value="Nyanga">Nyanga</MenuItem>
                                                                                <MenuItem
                                                                                    value="Plumtree">Plumtree</MenuItem>
                                                                                <MenuItem
                                                                                    value="Redcliff">Redcliff</MenuItem>
                                                                                <MenuItem
                                                                                    value="Rusape">Rusape</MenuItem>
                                                                                <MenuItem value="Ruwa">Ruwa</MenuItem>
                                                                                <MenuItem
                                                                                    value="Sakubva">Sakubva</MenuItem>
                                                                                <MenuItem
                                                                                    value="Shamva">Shamva</MenuItem>
                                                                                <MenuItem
                                                                                    value="Shurugwi">Shurugwi</MenuItem>
                                                                                <MenuItem value="Victoria Falls">Victoria
                                                                                    Falls</MenuItem>
                                                                                <MenuItem
                                                                                    value="Zvishavane">Zvishavane</MenuItem>

                                                                            </TextField>

                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <hr/>
                                                                <div>
                                                                    <div className="row mt-3">
                                                                        <h5 className="text-primary font-weight-bold">Documents</h5>
                                                                    </div>
                                                                    <div className="row mb-4">
                                                                        <div className="col-md-6">

                                                                            <div className="row mb-3">
                                                                                {uploadLoading1 && (
                                                                                    <span className="mt-2 mb-2 p-2">
                                        <Spinner
                                            size="medium"
                                            message="Uploading File....."
                                            line-fg-color="#64c3c2"
                                        />
                                    </span>
                                                                                )}
                                                                                {message !== '' && !uploadLoading1 && (
                                                                                    <span className="text-success">
                                        <br/>File Saved&nbsp;<i className="fa fa-check"/>
                                    </span>
                                                                                )}
                                                                                {message === '' && !uploadLoading1 && (
                                                                                    <div className="col-md-6 mb-2">

                                                                                        <label htmlFor="inputEmail4">Upload
                                                                                            Client Document</label>
                                                                                        <br/>
                                                                                        <label
                                                                                            className="text-muted text-sm-center">*
                                                                                            Select File</label>
                                                                                        &nbsp;&nbsp;
                                                                                        {/*<span style={{display: "none"}} id="uploadingLoader"/>*/}

                                                                                        <div>
                                                                                            {message === '' && !uploadLoading1 && (
                                                                                                <label
                                                                                                    className="btn btn-sm btn-primary"
                                                                                                    htmlFor="my-file-selector">
                                                                                                    <input
                                                                                                        id="my-file-selector"
                                                                                                        type="file"
                                                                                                        name="claimantCertificate"
                                                                                                        style={{display: "none"}}
                                                                                                        accept=".pdf, .docx, .doc"
                                                                                                        onChange={handleFileChange1}
                                                                                                    />
                                                                                                    <i className="fa fa-folder-open"/>&nbsp;&nbsp;
                                                                                                    Browse
                                                                                                </label>
                                                                                            )}
                                                                                            <div className="p-3"/>
                                                                                        </div>
                                                                                    </div>
                                                                                )}


                                                                            </div>


                                                                        </div>

                                                                    </div>
                                                                </div>

                                                                <div className="row">
                                                                    <button className="btn btn-sm btn-primary"
                                                                            onClick={handleSave}>
                                                                        <i className="fa-solid fa-paper-plane"></i>&nbsp;
                                                                        Submit Claim Form
                                                                    </button>
                                                                </div>
                                                            </div>

                                                        </div>
                                                    )}

                                                </div>
                                            </div>
                                        </form>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AddInothoAccident;
